import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '*',
            redirect: '/logginn'
        },


        {
            path: '/logginn',
            name: 'login',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/Login.vue'),
            meta: {
                guest: true
            }
        },

        {
            path: '/meldinn/:hall?',
            name: 'signup',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/Signup.vue'),
            meta: {
                guest: true
            },
            // component: () => import(/* webpackChunkName: "about" */ './views/Error.vue'),
            // props: { description: "Registrering online er ikke tilgjengelig nå"},
        },


        {
            path: '/feil',
            name: 'error',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/Error.vue'),
        },




        // Actual admin

        {
            path: '/verifisering',
            name: 'verification',
            component: () => import(/* webpackChunkName: "verification" */ './views/Verification.vue'),
            meta: {
                auth: true
            }
        },

        {
            path: '/oppgrader',
            name: 'upgrade',
            component: () => import(/* webpackChunkName: "upgrade" */ './views/Upgrade.vue'),
            meta: {
                auth: true
            }
        },

        {
            path: '/',
            name: 'home',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/Home.vue'),
            meta: {
                auth: true
            }
        },
        {
            path: '/overforing',
            name: 'transfer',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "transfer" */ './views/Transfer.vue'),
            meta: {
                auth: true
            }
        },
        {
            path: '/overforing/behandler',
            name: 'handleTransfer',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "handle-transfer" */ './views/HandleTransfer.vue'),
            meta: {
                auth: true
            }
        },

        {
            path: '/utbetaling',
            name: 'payout',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "transfer" */ './views/Payout.vue'),
            meta: {
                auth: true
            }
        },

        {
            path: '/bankkonto',
            name: 'bankaccount',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "transfer" */ './views/BankAccount.vue'),
            meta: {
                auth: true
            }
        },

        {
            path: '/blokkeringsoversikt',
            name: 'blocks',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "transactions" */ './views/Blocks.vue'),
            meta: {
                auth: true
            }
        },
        {
            path: '/bruksoversikt',
            name: 'spending',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "transactions" */ './views/Spending.vue'),
            meta: {
                auth: true
            }
        },
        {
            path: '/transaksjoner',
            name: 'transactions',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "transactions" */ './views/Transactions.vue'),
            meta: {
                auth: true
            }
        },
        {
            path: '/min-side',
            name: 'settings',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "settings" */ './views/Settings.vue'),
            meta: {
                auth: true
            }
        },
        {
            path: '/blokker',
            name: 'block',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "block" */ './views/Block.vue'),
            meta: {
                auth: true
            }
        },
        {
            path: '/pause',
            name: 'block',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "block" */ './views/Pause.vue'),
            meta: {
                auth: true
            }
        },
        {
            path: '/medlemskort',
            name: 'membercard',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "membercard" */ './views/MemberCard.vue'),
            meta: {
                auth: true
            }
        },
        {
            path: '/nytt-kort',
            name: 'newcard',
            component: () => import(/* webpackChunkName: "newcard" */ './views/NewCard.vue'),
            meta: {
                auth: true
            }
        },
        {
            path: '/spillhaller',
            name: 'games',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "membercard" */ './views/Games.vue'),
            meta: {
                auth: true
            }
        }

    ]
})
